<template>
  <div class="imei-stock-tab">
    <div class="imei-stock-tab__search-row d-flex flex-wrap align-items-center mb-2">
      <div class="imei-stock-tab__search flex-grow-1">
        <b-input-group size="sm">
          <b-input-group-prepend is-text>
            <i class="fas fa-search text-muted"></i>
          </b-input-group-prepend>
          <b-input
            :value="searchTerm"
            placeholder="Tìm / scan barcode IMEI..."
            autocomplete="off"
            @input="$emit('update:searchTerm', $event)"
            @keyup="$emit('search')"
          />
        </b-input-group>
      </div>
      <ImeiInputModalToolbar
        :export-disabled="exportDisabled"
        @template="$emit('template')"
        @import="$emit('import')"
        @export="$emit('export')"
      />
    </div>

    <div class="imei-modal-stats mb-2">
      <span class="badge badge-light imei-modal-stats__badge">Tổng tồn kho: {{ totalCount }}</span>
      <span class="badge badge-light imei-modal-stats__badge">Kết quả lọc: {{ filteredCount }}</span>
      <span class="badge badge-light imei-modal-stats__badge">Đã chọn: {{ selectedCount }}</span>
    </div>

    <b-table
      :items="items"
      :fields="tableFields"
      :per-page="perPage"
      :current-page="currentPage"
      :busy="loading"
      bordered
      hover
      small
      class="imei-modal-table mb-2"
    >
      <template #table-busy>
        <div class="text-center my-3">
          <b-spinner small type="grow" variant="primary" />
        </div>
      </template>
      <template #cell(stt)="row">
        <span>{{ stockRowStt(row.index) }}</span>
      </template>
      <template #cell(actions)="row">
        <div class="d-flex justify-content-center">
          <b-form-checkbox
            :checked="row.item.selected"
            size="lg"
            @change="(checked) => onToggleSelected(row.item, checked)"
          />
        </div>
      </template>
    </b-table>

    <b-pagination
      v-show="filteredCount > perPage"
      :value="currentPage"
      :total-rows="filteredCount"
      :per-page="perPage"
      align="right"
      size="sm"
      class="mb-0"
      @input="$emit('update:currentPage', $event)"
    />
  </div>
</template>

<script>
  import ImeiInputModalToolbar from './ImeiInputModalToolbar.vue'

  export default {
    name: 'ImeiInputStockTab',
    components: { ImeiInputModalToolbar },
    props: {
      items: { type: Array, default: () => [] },
      searchTerm: { type: String, default: '' },
      loading: { type: Boolean, default: false },
      currentPage: { type: Number, default: 1 },
      perPage: { type: Number, default: 50 },
      totalCount: { type: Number, default: 0 },
      filteredCount: { type: Number, default: 0 },
      selectedCount: { type: Number, default: 0 },
      exportDisabled: { type: Boolean, default: false },
    },
    computed: {
      tableFields() {
        return [
          {
            key: 'stt',
            label: 'STT',
            thStyle: { width: '56px', fontWeight: 600, color: '#181c32' },
            tdClass: 'text-center',
          },
          {
            key: 'imeiCode',
            label: 'IMEI',
            thStyle: { fontWeight: 600, color: '#181c32' },
          },
          {
            key: 'actions',
            label: 'Chọn',
            thStyle: { width: '72px', fontWeight: 600, color: '#181c32' },
            tdClass: 'text-center',
          },
        ]
      },
    },
    methods: {
      stockRowStt(index) {
        return (this.currentPage - 1) * this.perPage + index + 1
      },
      onToggleSelected(item, checked) {
        this.$emit('toggle-selected', { item, selected: checked })
      },
    },
  }
</script>

<style scoped>
  .imei-stock-tab__search-row {
    gap: 10px 12px;
  }
  .imei-stock-tab__search {
    min-width: 200px;
  }
  .imei-modal-stats {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  .imei-modal-stats__badge {
    font-size: 12px;
    font-weight: 500;
    color: #3f4254;
    padding: 6px 10px;
  }
</style>
